import _createForOfIteratorHelper from "D:/svnworkspace/GZEB/webWorks/e-boat-web/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _isEmpty from "lodash/isEmpty";
import _cloneDeep from "lodash/cloneDeep";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.string.includes.js";
import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock } from "vue";
var _hoisted_1 = {
  style: {
    "flex": "1",
    "position": "relative"
  }
};
var _hoisted_2 = {
  style: {
    "position": "absolute",
    "top": "0",
    "left": "0",
    "right": "0",
    "bottom": "0",
    "margin-top": "10px"
  }
};
var _hoisted_3 = {
  class: "input-with-select el-input el-input-group"
};
var _hoisted_4 = {
  key: 0,
  class: "el-input-group__append"
};
import * as api from '../../api/code-gen';
import * as CODE_GEN from '../../constant/code-gen';
import * as CodeGenHelper from '../../util/codegen-helper';
import { toast } from '@/utils/message';
import { Setting } from '@element-plus/icons-vue';
import storage from '@/utils/storage';
import { XTable } from '@/components/index';

import { ref, reactive, computed, watch, onMounted } from 'vue';
var TABLE_CACHE_PREFIX = 'dev:codegen:table-prop:';
export default /*@__PURE__*/_defineComponent({
  __name: 'TableProp',
  props: {
    tableName: {
      default: ''
    }
  },
  setup: function setup(__props, _ref) {
    var __expose = _ref.expose;
    var tableRef = ref();
    var props = __props;
    var table = ref({
      loading: false,
      data: [],
      action: {
        query: false,
        table: false,
        create: false,
        update: false,
        export: false
      },
      business: null,
      showCommonProp: false
    });
    var options = reactive({
      propType: CODE_GEN.SELECT_OPTIONS.PROP_TYPE,
      uiComponent: CODE_GEN.SELECT_OPTIONS.UI_COMPONENT,
      matchMethod: CODE_GEN.SELECT_OPTIONS.MATCH_METHOD
    });
    var tableCacheName = computed(function () {
      return "".concat(TABLE_CACHE_PREFIX).concat(props.tableName);
    });
    watch(function () {
      return props.tableName;
    }, function () {
      clearTable();
      performQuery();
    });
    watch(function () {
      return table.value.showCommonProp;
    }, function (val) {
      if (val) {
        return;
      }
      var data = table.value.data;
      if (!data || data.length < 1) {
        return;
      }
      // 如果隐藏了公共属性 则将公共属性的所有操作禁用
      var _iterator = _createForOfIteratorHelper(data),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;
          if (item.common && item.actions) {
            for (var _i = 0, _Object$values = Object.values(item.actions); _i < _Object$values.length; _i++) {
              var ac = _Object$values[_i];
              ac.enable = false;
            }
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    });
    onMounted(function () {
      performQuery();
    });
    function handleActionToggle(action, toggle) {
      updateActionSelection(action, toggle);
    }
    function handleRefresh() {
      clearTableCache();
      performQuery();
    }
    function performQuery() {
      if (table.value.loading || !props.tableName) {
        return;
      }
      startLoading();
      if (hasTableCache()) {
        table.value = getTableCache();
        stopLoading();
      } else {
        api.getBusiness(props.tableName).then(function (result) {
          table.value.business = _cloneDeep(result.data);
          var props = result.data.properties;
          prepareProps(props);
          table.value.data = props;
        }).finally(function () {
          stopLoading();
        });
      }
    }
    function prepareProps(propArr) {
      if (propArr && propArr.length > 0) {
        var _iterator2 = _createForOfIteratorHelper(propArr),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var prop = _step2.value;
            prepareAction(prop);
            prepareUiComponent(prop);
            deduceCommonProp(prop);
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
    }
    function prepareUiComponent(prop) {
      if (!prop.uiComponent) {
        prop.uiComponent = {
          name: CODE_GEN.UI_COMPONENTS.INPUT.name
        };
      }
      if (!prop.uiComponent.attributes) {
        prop.uiComponent.attributes = {};
      }
    }
    function prepareAction(prop) {
      if (!prop.actions) {
        var actions = {};
        actions[CODE_GEN.ACTIONS.QUERY] = {
          enable: false,
          name: CODE_GEN.ACTIONS.QUERY,
          config: {}
        };
        actions[CODE_GEN.ACTIONS.TABLE] = {
          enable: false,
          name: CODE_GEN.ACTIONS.TABLE,
          config: {}
        };
        actions[CODE_GEN.ACTIONS.CREATE] = {
          enable: false,
          name: CODE_GEN.ACTIONS.CREATE,
          config: {}
        };
        actions[CODE_GEN.ACTIONS.UPDATE] = {
          enable: false,
          name: CODE_GEN.ACTIONS.UPDATE,
          config: {}
        };
        actions[CODE_GEN.ACTIONS.EXPORT] = {
          enable: false,
          name: CODE_GEN.ACTIONS.EXPORT,
          config: {}
        };
        actions[CODE_GEN.ACTIONS.IMPORT] = {
          enable: false,
          name: CODE_GEN.ACTIONS.IMPORT,
          config: {}
        };
        prop.actions = actions;
      } else {
        for (var _i2 = 0, _Object$values2 = Object.values(prop.actions); _i2 < _Object$values2.length; _i2++) {
          var action = _Object$values2[_i2];
          action.enable = false;
          if (!action.config) {
            action.config = {};
          }
        }
      }
    }
    function deduceCommonProp(prop) {
      prop.common = CODE_GEN.COMMON_COLUMNS.includes(prop.columnName.toLowerCase());
    }
    function deduceRowStyle(_ref2) {
      var row = _ref2.row;
      if (!row.common) {
        return {};
      }
      if (table.value.showCommonProp) {
        return {};
      } else {
        return {
          display: 'none'
        };
      }
    }
    function updateActionSelection(action, selection) {
      var data = table.value.data;
      if (!data || data.length < 1) {
        return;
      }
      var _iterator3 = _createForOfIteratorHelper(data),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var item = _step3.value;
          // 如果是公共属性且不显示公共属性则不更新选择状态
          if (item.common && !table.value.showCommonProp) {
            continue;
          }
          var actions = item.actions;
          if (actions && actions[action]) {
            actions[action].enable = selection;
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    }
    function clearTable() {
      table.value.business = null;
      table.value.data = [];
    }
    function startLoading() {
      table.value.loading = true;
    }
    function stopLoading() {
      table.value.loading = false;
    }
    function getBusiness() {
      if (table.value.data.length < 1) {
        return;
      }
      if (!table.value.business || table.value.loading) {
        toast.warn('属性未加载完毕');
        return;
      }
      var _iterator4 = _createForOfIteratorHelper(table.value.data),
        _step4;
      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var prop = _step4.value;
          if (_isEmpty(prop.propName)) {
            toast.warn("\u8BF7\u8F93\u5165\u5B57\u6BB5".concat(prop.columnName, "\u5BF9\u5E94\u7684\u5C5E\u6027\u540D\u79F0"));
            return;
          }
          if (_isEmpty(prop.propComment)) {
            toast.warn("\u8BF7\u8F93\u5165\u5B57\u6BB5".concat(prop.columnName, "\u5BF9\u5E94\u7684\u5C5E\u6027\u63CF\u8FF0"));
            return;
          }
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
      var business = _cloneDeep(table.value.business);
      var props = _cloneDeep(table.value.data);
      pruneActions(props);
      representComponent(props);
      business.properties = props;
      setTableCache(table.value);
      return business;
    }
    function pruneActions(properties) {
      if (_isEmpty(properties)) {
        return;
      }
      var _iterator5 = _createForOfIteratorHelper(properties),
        _step5;
      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var prop = _step5.value;
          if (!prop.actions) {
            continue;
          }
          // 删除未启用的操作
          for (var _i3 = 0, _Object$keys = Object.keys(prop.actions); _i3 < _Object$keys.length; _i3++) {
            var k = _Object$keys[_i3];
            if (!prop.actions[k].enable) {
              delete prop.actions[k];
            }
          }
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
    }
    function representComponent(properties) {
      if (_isEmpty(properties)) {
        return;
      }
      var _iterator6 = _createForOfIteratorHelper(properties),
        _step6;
      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var prop = _step6.value;
          var comp = prop.uiComponent;
          if (comp) {
            var _CODE_GEN$getComponen;
            comp.represent = (_CODE_GEN$getComponen = CODE_GEN.getComponentByName(comp.name)) === null || _CODE_GEN$getComponen === void 0 ? void 0 : _CODE_GEN$getComponen.represent;
            if (!comp.attributes) {
              comp.attributes = {};
            }
            if (comp.attributes.dictCode) {
              comp.attributes['dict-code'] = comp.attributes.dictCode;
              delete comp.attributes.dictCode;
            }
            Object.assign(comp.attributes, CodeGenHelper.deduceComponentAttrs(prop));
          }
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }
    }
    function clearTableCache() {
      storage.remove(tableCacheName.value);
    }
    function hasTableCache() {
      return storage.has(tableCacheName.value);
    }
    function getTableCache() {
      return storage.get(tableCacheName.value);
    }
    function setTableCache(tb) {
      storage.set(tableCacheName.value, tb);
    }
    __expose({
      getBusiness: getBusiness
    });
    return function (_ctx, _cache) {
      var _component_el_button = _resolveComponent("el-button");
      var _component_el_col = _resolveComponent("el-col");
      var _component_el_checkbox = _resolveComponent("el-checkbox");
      var _component_el_row = _resolveComponent("el-row");
      var _component_el_table_column = _resolveComponent("el-table-column");
      var _component_el_input = _resolveComponent("el-input");
      var _component_x_select = _resolveComponent("x-select");
      var _component_el_popover = _resolveComponent("el-popover");
      var _component_el_divider = _resolveComponent("el-divider");
      var _component_el_switch = _resolveComponent("el-switch");
      var _component_el_form_item = _resolveComponent("el-form-item");
      var _component_el_form = _resolveComponent("el-form");
      var _component_el_link = _resolveComponent("el-link");
      var _component_XAppLayout = _resolveComponent("XAppLayout");
      var _directive_loading = _resolveDirective("loading");
      return _ctx.tableName ? (_openBlock(), _createBlock(_component_XAppLayout, {
        key: 0
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_row, null, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_col, {
                span: 2
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_el_button, {
                    type: "primary",
                    onClick: handleRefresh
                  }, {
                    default: _withCtx(function () {
                      return _cache[11] || (_cache[11] = [_createTextVNode("刷新")]);
                    }),
                    _: 1
                  })];
                }),
                _: 1
              }), _createVNode(_component_el_col, {
                span: 2,
                offset: 18
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_el_checkbox, {
                    modelValue: _unref(table).showCommonProp,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
                      return _unref(table).showCommonProp = $event;
                    }),
                    label: "显示公共属性",
                    border: "",
                    size: "small"
                  }, null, 8, ["modelValue"])];
                }),
                _: 1
              })];
            }),
            _: 1
          }), _createElementVNode("div", _hoisted_1, [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_unref(XTable), {
            ref_key: "tableRef",
            ref: tableRef,
            data: _unref(table).data,
            "show-index": "",
            "el-table-props": {
              rowStyle: deduceRowStyle
            }
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_table_column, {
                label: "字段名称",
                prop: "columnName",
                "min-width": "120",
                align: "center"
              }), _createVNode(_component_el_table_column, {
                label: "字段类型",
                prop: "columnType",
                "min-width": "120",
                align: "center"
              }), _createVNode(_component_el_table_column, {
                label: "字段描述",
                prop: "columnComment",
                "min-width": "120",
                align: "center",
                "show-tooltip-when-overflow": ""
              }), _createVNode(_component_el_table_column, {
                label: "实体定义",
                align: "center"
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_el_table_column, {
                    label: "属性名称",
                    prop: "propName",
                    "min-width": "120",
                    align: "center"
                  }, {
                    default: _withCtx(function (_ref3) {
                      var row = _ref3.row;
                      return [_createVNode(_component_el_input, {
                        modelValue: row.propName,
                        "onUpdate:modelValue": function onUpdateModelValue($event) {
                          return row.propName = $event;
                        }
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])];
                    }),
                    _: 1
                  }), _createVNode(_component_el_table_column, {
                    label: "属性类型",
                    prop: "propType",
                    "min-width": "120",
                    align: "center"
                  }, {
                    default: _withCtx(function (_ref4) {
                      var row = _ref4.row;
                      return [_createVNode(_component_x_select, {
                        modelValue: row.propType,
                        "onUpdate:modelValue": function onUpdateModelValue($event) {
                          return row.propType = $event;
                        },
                        options: _unref(options).propType
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "options"])];
                    }),
                    _: 1
                  }), _createVNode(_component_el_table_column, {
                    label: "属性描述",
                    prop: "propComment",
                    "min-width": "120",
                    align: "center"
                  }, {
                    default: _withCtx(function (_ref5) {
                      var row = _ref5.row;
                      return [_createVNode(_component_el_input, {
                        modelValue: row.propComment,
                        "onUpdate:modelValue": function onUpdateModelValue($event) {
                          return row.propComment = $event;
                        }
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])];
                    }),
                    _: 1
                  })];
                }),
                _: 1
              }), _createVNode(_component_el_table_column, {
                label: "UI组件",
                "min-width": "140",
                align: "center"
              }, {
                default: _withCtx(function (_ref6) {
                  var row = _ref6.row;
                  return [_createElementVNode("div", _hoisted_3, [_createVNode(_component_x_select, {
                    modelValue: row.uiComponent.name,
                    "onUpdate:modelValue": function onUpdateModelValue($event) {
                      return row.uiComponent.name = $event;
                    },
                    class: "select",
                    options: _unref(options).uiComponent
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]), row.uiComponent.name === 'select' ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createVNode(_component_el_popover, {
                    placement: "left",
                    width: "100"
                  }, {
                    reference: _withCtx(function () {
                      return [_createVNode(_component_el_button, {
                        icon: _unref(Setting)
                      }, null, 8, ["icon"])];
                    }),
                    default: _withCtx(function () {
                      return [_createVNode(_component_el_input, {
                        modelValue: row.uiComponent.attributes.dictCode,
                        "onUpdate:modelValue": function onUpdateModelValue($event) {
                          return row.uiComponent.attributes.dictCode = $event;
                        },
                        placeholder: "关联字典代码"
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])];
                    }),
                    _: 2
                  }, 1024)])) : _createCommentVNode("", true)])];
                }),
                _: 1
              }), _createVNode(_component_el_table_column, {
                label: "功能",
                align: "center"
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_el_table_column, {
                    label: "查询",
                    width: "80",
                    align: "center"
                  }, {
                    header: _withCtx(function () {
                      return [_createVNode(_component_el_checkbox, {
                        modelValue: _unref(table).action.query,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
                          return _unref(table).action.query = $event;
                        }),
                        onChange: _cache[2] || (_cache[2] = function ($event) {
                          return handleActionToggle('query', _unref(table).action.query);
                        })
                      }, {
                        default: _withCtx(function () {
                          return _cache[12] || (_cache[12] = [_createTextVNode("查询")]);
                        }),
                        _: 1
                      }, 8, ["modelValue"])];
                    }),
                    default: _withCtx(function (_ref7) {
                      var row = _ref7.row;
                      return [_createVNode(_component_el_checkbox, {
                        modelValue: row.actions.query.enable,
                        "onUpdate:modelValue": function onUpdateModelValue($event) {
                          return row.actions.query.enable = $event;
                        }
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])];
                    }),
                    _: 1
                  }), _createVNode(_component_el_table_column, {
                    label: "列表",
                    width: "80",
                    align: "center"
                  }, {
                    header: _withCtx(function () {
                      return [_createVNode(_component_el_checkbox, {
                        modelValue: _unref(table).action.table,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) {
                          return _unref(table).action.table = $event;
                        }),
                        onChange: _cache[4] || (_cache[4] = function ($event) {
                          return handleActionToggle('table', _unref(table).action.table);
                        })
                      }, {
                        default: _withCtx(function () {
                          return _cache[13] || (_cache[13] = [_createTextVNode("列表")]);
                        }),
                        _: 1
                      }, 8, ["modelValue"])];
                    }),
                    default: _withCtx(function (_ref8) {
                      var row = _ref8.row;
                      return [_createVNode(_component_el_checkbox, {
                        modelValue: row.actions.table.enable,
                        "onUpdate:modelValue": function onUpdateModelValue($event) {
                          return row.actions.table.enable = $event;
                        }
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])];
                    }),
                    _: 1
                  }), _createVNode(_component_el_table_column, {
                    label: "新增",
                    width: "80",
                    align: "center"
                  }, {
                    header: _withCtx(function () {
                      return [_createVNode(_component_el_checkbox, {
                        modelValue: _unref(table).action.create,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = function ($event) {
                          return _unref(table).action.create = $event;
                        }),
                        onChange: _cache[6] || (_cache[6] = function ($event) {
                          return handleActionToggle('create', _unref(table).action.create);
                        })
                      }, {
                        default: _withCtx(function () {
                          return _cache[14] || (_cache[14] = [_createTextVNode("新增")]);
                        }),
                        _: 1
                      }, 8, ["modelValue"])];
                    }),
                    default: _withCtx(function (_ref9) {
                      var row = _ref9.row;
                      return [_createVNode(_component_el_checkbox, {
                        modelValue: row.actions.create.enable,
                        "onUpdate:modelValue": function onUpdateModelValue($event) {
                          return row.actions.create.enable = $event;
                        }
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])];
                    }),
                    _: 1
                  }), _createVNode(_component_el_table_column, {
                    label: "修改",
                    width: "80",
                    align: "center"
                  }, {
                    header: _withCtx(function () {
                      return [_createVNode(_component_el_checkbox, {
                        modelValue: _unref(table).action.update,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = function ($event) {
                          return _unref(table).action.update = $event;
                        }),
                        onChange: _cache[8] || (_cache[8] = function ($event) {
                          return handleActionToggle('update', _unref(table).action.update);
                        })
                      }, {
                        default: _withCtx(function () {
                          return _cache[15] || (_cache[15] = [_createTextVNode("修改")]);
                        }),
                        _: 1
                      }, 8, ["modelValue"])];
                    }),
                    default: _withCtx(function (_ref10) {
                      var row = _ref10.row;
                      return [_createVNode(_component_el_checkbox, {
                        modelValue: row.actions.update.enable,
                        "onUpdate:modelValue": function onUpdateModelValue($event) {
                          return row.actions.update.enable = $event;
                        }
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])];
                    }),
                    _: 1
                  }), _createVNode(_component_el_table_column, {
                    label: "导入/导出",
                    width: "120",
                    align: "center"
                  }, {
                    header: _withCtx(function () {
                      return [_createVNode(_component_el_checkbox, {
                        modelValue: _unref(table).action.export,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = function ($event) {
                          return _unref(table).action.export = $event;
                        }),
                        onChange: _cache[10] || (_cache[10] = function ($event) {
                          return handleActionToggle('export', _unref(table).action.export);
                        })
                      }, {
                        default: _withCtx(function () {
                          return _cache[16] || (_cache[16] = [_createTextVNode("导入/导出")]);
                        }),
                        _: 1
                      }, 8, ["modelValue"])];
                    }),
                    default: _withCtx(function (_ref11) {
                      var row = _ref11.row;
                      return [_createVNode(_component_el_checkbox, {
                        modelValue: row.actions.export.enable,
                        "onUpdate:modelValue": function onUpdateModelValue($event) {
                          return row.actions.export.enable = $event;
                        }
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])];
                    }),
                    _: 1
                  }), _createVNode(_component_el_table_column, {
                    label: "操作",
                    width: "100",
                    align: "center"
                  }, {
                    default: _withCtx(function (_ref12) {
                      var row = _ref12.row;
                      return [_createVNode(_component_el_popover, {
                        placement: "left",
                        title: "\u914D\u7F6E - ".concat(row.propComment),
                        width: "280",
                        trigger: "click"
                      }, {
                        default: _withCtx(function () {
                          return [_createVNode(_component_el_divider, null, {
                            default: _withCtx(function () {
                              return [_createVNode(_component_el_checkbox, {
                                modelValue: row.actions.query.enable,
                                "onUpdate:modelValue": function onUpdateModelValue($event) {
                                  return row.actions.query.enable = $event;
                                }
                              }, {
                                default: _withCtx(function () {
                                  return _cache[17] || (_cache[17] = [_createTextVNode("查询")]);
                                }),
                                _: 2
                              }, 1032, ["modelValue", "onUpdate:modelValue"])];
                            }),
                            _: 2
                          }, 1024), _createVNode(_component_el_form, {
                            disabled: !row.actions.query.enable,
                            inline: ""
                          }, {
                            default: _withCtx(function () {
                              return [_createVNode(_component_el_form_item, {
                                label: "是否必填"
                              }, {
                                default: _withCtx(function () {
                                  return [_createVNode(_component_el_switch, {
                                    modelValue: row.actions.query.config.required,
                                    "onUpdate:modelValue": function onUpdateModelValue($event) {
                                      return row.actions.query.config.required = $event;
                                    }
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"])];
                                }),
                                _: 2
                              }, 1024), _createVNode(_component_el_form_item, {
                                label: "匹配方法"
                              }, {
                                default: _withCtx(function () {
                                  return [_createVNode(_component_x_select, {
                                    modelValue: row.actions.query.config.match_method,
                                    "onUpdate:modelValue": function onUpdateModelValue($event) {
                                      return row.actions.query.config.match_method = $event;
                                    },
                                    style: {
                                      "width": "120px"
                                    },
                                    options: _unref(options).matchMethod
                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "options"])];
                                }),
                                _: 2
                              }, 1024)];
                            }),
                            _: 2
                          }, 1032, ["disabled"]), _createVNode(_component_el_divider, null, {
                            default: _withCtx(function () {
                              return [_createVNode(_component_el_checkbox, {
                                modelValue: row.actions.table.enable,
                                "onUpdate:modelValue": function onUpdateModelValue($event) {
                                  return row.actions.table.enable = $event;
                                }
                              }, {
                                default: _withCtx(function () {
                                  return _cache[18] || (_cache[18] = [_createTextVNode("列表")]);
                                }),
                                _: 2
                              }, 1032, ["modelValue", "onUpdate:modelValue"])];
                            }),
                            _: 2
                          }, 1024), _createVNode(_component_el_form, {
                            disabled: !row.actions.table.enable,
                            inline: ""
                          }, {
                            default: _withCtx(function () {
                              return [_createVNode(_component_el_form_item, {
                                label: "支持排序"
                              }, {
                                default: _withCtx(function () {
                                  return [_createVNode(_component_el_switch, {
                                    modelValue: row.actions.table.config.sortable,
                                    "onUpdate:modelValue": function onUpdateModelValue($event) {
                                      return row.actions.table.config.sortable = $event;
                                    }
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"])];
                                }),
                                _: 2
                              }, 1024)];
                            }),
                            _: 2
                          }, 1032, ["disabled"]), _createVNode(_component_el_divider, null, {
                            default: _withCtx(function () {
                              return [_createVNode(_component_el_checkbox, {
                                modelValue: row.actions.create.enable,
                                "onUpdate:modelValue": function onUpdateModelValue($event) {
                                  return row.actions.create.enable = $event;
                                }
                              }, {
                                default: _withCtx(function () {
                                  return _cache[19] || (_cache[19] = [_createTextVNode("新增")]);
                                }),
                                _: 2
                              }, 1032, ["modelValue", "onUpdate:modelValue"])];
                            }),
                            _: 2
                          }, 1024), _createVNode(_component_el_form, {
                            disabled: !row.actions.create.enable,
                            inline: ""
                          }, {
                            default: _withCtx(function () {
                              return [_createVNode(_component_el_form_item, {
                                label: "是否必填"
                              }, {
                                default: _withCtx(function () {
                                  return [_createVNode(_component_el_switch, {
                                    modelValue: row.actions.create.config.required,
                                    "onUpdate:modelValue": function onUpdateModelValue($event) {
                                      return row.actions.create.config.required = $event;
                                    }
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"])];
                                }),
                                _: 2
                              }, 1024)];
                            }),
                            _: 2
                          }, 1032, ["disabled"]), _createVNode(_component_el_divider, null, {
                            default: _withCtx(function () {
                              return [_createVNode(_component_el_checkbox, {
                                modelValue: row.actions.update.enable,
                                "onUpdate:modelValue": function onUpdateModelValue($event) {
                                  return row.actions.update.enable = $event;
                                }
                              }, {
                                default: _withCtx(function () {
                                  return _cache[20] || (_cache[20] = [_createTextVNode("修改")]);
                                }),
                                _: 2
                              }, 1032, ["modelValue", "onUpdate:modelValue"])];
                            }),
                            _: 2
                          }, 1024), _createVNode(_component_el_form, {
                            disabled: !row.actions.update.enable,
                            inline: ""
                          }, {
                            default: _withCtx(function () {
                              return [_createVNode(_component_el_form_item, {
                                label: "是否必填"
                              }, {
                                default: _withCtx(function () {
                                  return [_createVNode(_component_el_switch, {
                                    modelValue: row.actions.update.config.required,
                                    "onUpdate:modelValue": function onUpdateModelValue($event) {
                                      return row.actions.update.config.required = $event;
                                    }
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"])];
                                }),
                                _: 2
                              }, 1024)];
                            }),
                            _: 2
                          }, 1032, ["disabled"])];
                        }),
                        reference: _withCtx(function () {
                          return [_createVNode(_component_el_link, {
                            type: "primary",
                            icon: _unref(Setting)
                          }, {
                            default: _withCtx(function () {
                              return _cache[21] || (_cache[21] = [_createTextVNode("配置")]);
                            }),
                            _: 1
                          }, 8, ["icon"])];
                        }),
                        _: 2
                      }, 1032, ["title"])];
                    }),
                    _: 1
                  })];
                }),
                _: 1
              })];
            }),
            _: 1
          }, 8, ["data", "el-table-props"])])), [[_directive_loading, _unref(table).loading]])])];
        }),
        _: 1
      })) : _createCommentVNode("", true);
    };
  }
});